<template>
  <div class="dynamic">
    <Header :navIndex="navIndex"></Header>
    <div v-if="showDetail === ''">
      <div class="top">
        <img class="line" src="../assets/index/line.png" alt="" />
        <div class="title">阁韵动态</div>
      </div>
      <!-- 状态切换 -->
      <div class="tab">
        <div class="icon"><img src="../assets/dynamic/icon.png" alt="" /></div>

        <div class="list">
          <div @click="changeTab(1)" :class="activeIndex === 1 ? 'active' : ''">
            阁韵新闻
          </div>
          <div
            @click="changeTab(2)"
            :class="activeIndex === 2 ? 'active' : ''"
            style="border-right: none"
          >
            媒体报道
          </div>
        </div>
      </div>
      <div class="contentWrap">
        <div
          class="newsWrap"
          @click="detail(item.id, item, listData)"
          v-for="(item, index) in listData"
          :key="index"
        >
          <div class="newsImg"><img :src="item.image" alt="" /></div>
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
            <div class="btn">了解详情</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="page">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        prev-text="上一页"
        next-text="下一页"
        background
        :current-page.sync="pagenum"
        layout="prev, pager, next"
        :page-size="pagesize"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- <div style="background: #f2f2f2" v-if="showDetail === 0">
      <div class="location">
        <div class="loca">
          您的位置:
          <span @click="$router.push('/')" style="cursor: pointer">首页</span> >
          <span @click="showDetail = ''" style="cursor: pointer">阁韵动态</span>
          >
          <span @click="showDetail = ''" style="cursor: pointer">阁韵新闻</span>
          >
          <span style="font-weight: bold"
            >家居装修，阳台选择封还是不封？为什么？
          </span>
        </div>
      </div>

      <div class="normal">
        <div class="cont">
          <div class="norTitle">家居装修，阳台选择封还是不封？为什么？</div>
          <div class="autho">
            作者： 铝包木门窗 编辑： 小木 来源： 铝包木门窗 发布日期：
            2021-12-15 15:20:21
          </div>
        </div>
        <div class="text">
          室内装修时，开放式阳台是不是要封起来，这个需要分情况，因地制宜的。
          <br />
          <br />
          一般北方的开放式阳台，一般会封闭，由于北方地区气侯干躁，沙尘大，冬天严寒，开放式阳台不好用，只有在夏天应用，春天大风，秋冬季蚊子，冬天严寒。北方地区的开放式阳台非常容易脏，尘土大，不太好清洗，温度差转变大。
          <br />
          <br />
          一般南方地区的气侯潮湿溫暖，无风沙，尘土小，应用开放式阳台的比较多。夏天酷热夜里能够在阳台乘凉，冬天能够在阳台日晒。可是南方地区多雨，因此一般阳台做挡风遮雨罩。
        </div>
        <div class="descImg"><img src="../assets/dynamic/1.png" alt="" /></div>
        <div class="text">
          一般开放式阳台，能够做休息区，庭院花园，达到阅读文章饮茶烤串锻练等娱乐日常生活。封闭式阳台能够做为室内空间设计应用，还可以与房间作用室内空间合拼，还可以单独切分开展应用，封闭阳台做全自动洗衣机，或是塌塌米，室内花园，观景平台等。<br />
          <br />
          像我们这的阳台大部分会封闭，由于春季有风沙，夏季又干又热，秋天蚊子，冬天严寒，做开放式阳台用途并不大。做封闭后，能够扩张室内空间设计，作为洗衣服，晾干衣服，健身会所，或是花室，水池，小园林景观。
        </div>
        <div class="descImg"><img src="../assets/dynamic/2.png" alt="" /></div>
        <div class="text">
          一种是全封闭，用断桥铝门窗，或是塑钢窗户，彻底封闭成室内空间设计。这类方法隔音降噪隔热保温比较好，缺陷是少了与外部触碰的室内空间。<br />
          <br />
          一种是半封闭。只封闭顶端和局部墙面窗子，挡风遮雨，留出一部分与外部通风换气，不开展封闭。这类方法优势是保存阳台的开放式，与此同时不会受到气温危害阳台应用。<br />
          <br />
          一种是主题活动封闭。运用移窗，或是隐型窗开展封闭，阳台在半封闭和全封闭开展转换。这类方法在南方地区应用比较多，多雨季节能够全封闭，转晴气温开启移窗，通风换气。
        </div>
        <div class="descImg"><img src="../assets/dynamic/3.png" alt="" /></div>
      </div>

      <div class="bottom">
        <div class="prew" @click="last()" v-if="0 < showDetail">
          <div class="last">上一条</div>
          <div class="sub">“量子大学专项学习班”第一期班会</div>
        </div>
        <div class="line"></div>
        <div class="prew" @click="next()">
          <div class="last">下一条</div>
          <div class="sub">GRÜNEN | 木窗里贮藏关于生活的诗歌阁韵</div>
        </div>
        <div class="back" @click="back">返回</div>
      </div>
    </div>

    <div style="background: #f2f2f2" v-else-if="showDetail === 1">
      <div class="location">
        <div class="loca">
          您的位置:
          <span @click="$router.push('/')" style="cursor: pointer">首页</span> >
          <span @click="showDetail = ''" style="cursor: pointer">阁韵动态</span>
          >
          <span @click="showDetail = ''" style="cursor: pointer">阁韵新闻</span>
          >
          <span style="font-weight: bold"
            >GRÜNEN | 木窗里贮藏关于生活的诗歌</span
          >
        </div>
      </div>
      <div class="normal">
        <div class="cont">
          <div class="norTitle">GRÜNEN | 木窗里贮藏关于生活的诗歌</div>
          <div class="autho">
            作者： 铝包木门窗 编辑： 小木 来源： 铝包木门窗 发布日期：
            2021-12-14 15:18:48
          </div>
        </div>
        <div class="descImg"><img src="../assets/dynamic/1.jpg" alt="" /></div>
        <div class="text" style="text-align: center">
          以阁韵木窗为起点 <br />
          打造都市家居最佳look<br />
          赋予生活绝对的新鲜感<br />
          开启多彩、自在的生活模式<br /><br />
          Start with wooden Windows<br />
          Create the best look of urban household<br />
          Give life an absolute freshness<br />
          Start a colorful lifestyle<br />
        </div>
        <div class="descImg"><img src="../assets/dynamic/2.jpg" alt="" /></div>
        <div class="text" style="text-align: center">
          Ü非一般意义的建筑用窗<br />
          甄选世界顶级原材<br />
          设计与自然相结合迸发出艺术气息<br />
          打破家居生活沉闷局限，拒绝单调装饰风格<br />
        </div>
        <div class="descImg"><img src="../assets/dynamic/3.jpg" alt="" /></div>
        <div class="text">
          阁韵木窗那独一无二的纹理，是自然的述说，当光线透过这扇窗的瞬间，你会发现一切变得更加迷人，焕发着呼之欲出的生命力。
        </div>
        <div class="descImg"><img src="../assets/dynamic/4.jpg" alt="" /></div>
        <div class="text">
          阁韵木窗散发出来的自由与生机，在家的每一个角落潺潺流淌，你可以在家中肆意的歌唱；你可以展开双臂尽情的旋转跳跃；你也可以把所有的束缚统统扔掉。<br />
          总之，你会不由自主的慢下来，感受这扇窗带给你的自然与沉静！
        </div>
      </div>
      <div class="bottom">
        <div class="prew" @click="last()" v-if="0 < showDetail">
          <div class="last">上一条</div>
          <div class="sub">家居装修，阳台选择封还是不封？为什么？</div>
        </div>
        <div class="line"></div>
        <div class="prew" @click="next(2)">
          <div class="last">下一条</div>
          <div class="sub">阁韵“量子大学专项学习班”第一期班会</div>
        </div>
        <div class="back" @click="back">返回</div>
      </div>
    </div>

    <div style="background: #f2f2f2" v-else-if="showDetail === 2">
      <div class="location">
        <div class="loca">
          您的位置:
          <span @click="$router.push('/')" style="cursor: pointer">首页</span> >
          <span @click="showDetail = ''" style="cursor: pointer">阁韵动态</span>
          >
          <span @click="showDetail = ''" style="cursor: pointer">阁韵新闻</span>
          >
          <span style="font-weight: bold"
            >阁韵“量子大学专项学习班”第一期班会
          </span>
        </div>
      </div>
      <div class="normal">
        <div class="cont">
          <div class="norTitle">阁韵“量子大学专项学习班”第一期班会</div>
          <div class="autho">
            作者： 铝包木门窗 编辑： 小木 来源： 铝包木门窗 发布日期：
            2021-12-06 15:23:18
          </div>
        </div>
        <div class="text">
          为提升阁韵公司全员的综合素质，加强各类知识储备，营造学习型企业氛围，2021年12月3日，阁韵公司组织了“量子大学专项学习班”第一期班会。公司50余人参会，会议由人资部赵经理主持，并特邀量子大学薛郦涓女士作为嘉宾进行特别分享。
        </div>
        <div class="descImg1">
          <img src="../assets/dynamic/31.jpg" alt="" />
        </div>
        <div class="text">
          会上，阁韵家人围绕近期学习的知识内容进行深入探讨和交流，在战略管理、精益生产、销售技能、职场压力等方面展开热烈的交流分享，并结合实际工作，逐一发言畅谈学习体会。
        </div>
        <div class="descImg1">
          <img src="../assets/dynamic/32.jpg" alt="" />
        </div>
        <div class="text">
          班会上，阁韵家人通过分享心得交流，不仅学习到个人在职场及生活中的心态修炼，也理解到如何从全局角度跨部门协调和沟通技巧，从理论到实际以及思维认识上都得到了最大的提升。
        </div>
        <div class="descImg1">
          <img src="../assets/dynamic/33.jpg" alt="" />
        </div>
        <div class="text">
          在班会的尾声，来自量子大学的特约嘉宾薛郦涓女士为阁韵家人进行本月课程学习重点知识的梳理，全面细致地再现了授课讲师的精彩环节。
        </div>
        <div class="descImg1">
          <img src="../assets/dynamic/34.jpg" alt="" />
        </div>
        <div class="text">
          最后，阁韵公司总经理张玉泉先生进行总结发言，对本次量子大学专项学习班的成果给予充分肯定并提出了要求，他指出，要做到学习教育入脑入心、融会贯通，切实运用学习到的知识推动工作的发展，把学习实效转化为干事的动力，达到学以致用，用有所成。
          <br />
          <br />
          阁韵公司此次引入量子大学学习平台，组织公司全员学习各类职场课程，以书为友，旨在激发阁韵家人的学习能力，助力阁韵人才的培养和积极快乐的工作，为营造一个良好的学习环境和企业文化氛围奠定优良夯实的基础。
        </div>
      </div>
      <div class="bottom">
        <div class="prew" @click="last()" v-if="0 < showDetail">
          <div class="last">上一条</div>
          <div class="sub">GRÜNEN | 木窗里贮藏关于生活的诗歌</div>
        </div>
        <div class="line"></div>
        <div class="prew" @click="next()">
          <div class="last">下一条</div>
          <div class="sub">阁韵“量子大学专项学习班”第一期班会</div>
        </div>
        <div class="back" @click="back">返回</div>
      </div>
    </div>

    <div style="background: #f2f2f2" v-else-if="showDetail != ''">
      <div class="location">
        <div class="loca">
          您的位置:
          <span @click="$router.push('/')" style="cursor: pointer">首页</span> >
          <span @click="showDetail = ''" style="cursor: pointer">阁韵动态</span>
          >
          <span @click="showDetail = ''" style="cursor: pointer">阁韵新闻</span>
          > <span style="font-weight: bold">{{ list[showDetail].title }} </span>
        </div>
      </div>
      <div class="normal">
        <div class="cont">
          <div class="norTitle">{{ list[showDetail].title }}</div>
          <div class="autho">
            作者： 铝包木门窗 编辑： 小木 来源： 铝包木门窗 发布日期：
            {{ list[showDetail].time }}
          </div>
        </div>
        <Detail :number="showDetail"></Detail>
      </div>
      <div class="bottom">
        <div class="prew" @click="last()" v-if="0 < showDetail">
          <div class="last">上一条</div>
          <div class="sub">{{ list[showDetail - 1].title }}</div>
        </div>
        <div class="line"></div>
        <div class="prew" @click="next()" v-if="showDetail < 10">
          <div class="last">下一条</div>
          <div class="sub">{{ list[showDetail + 1].title }}</div>
        </div>
        <div class="back" @click="back">返回</div>
      </div>
    </div> -->
    <Part5></Part5>
    <XFK></XFK>
  </div>
</template>

<script>
import Header from "../components/Header";
// import Detail from "../components/Detail";
import Part5 from "../components/Part5";
import XFK from "../components/XFK";
import { newsList, newsDetail } from "../api/request";

export default {
  name: "Dynamic",
  components: { Header, Part5, XFK },
  data() {
    return {
      // 总条目数
      total: 0,
      // 当前页数
      pagenum: 1,
      // 显示一页多少条数据
      pagesize: 4,

      navIndex: 5,
      // 新闻列表的当期项
      activeIndex: 1,
      showDetail: "",
      listData: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 状态切换
    changeTab(index) {
      // console.log(index);
      this.activeIndex = index;
      // console.log(this.activeIndex);
      // 点击每一个筛选总列表

      // if (this.activeIndex == 1) {
      //   newsList({
      //     type: 1,
      //     limit: this.pagesize,
      //     page: this.pagenum,
      //   }).then((res) => {
      //     if (res.data.code == 1) {
      //       // console.log(res.data.data);
      //       // 总条数
      //       this.total = res.data.data.total;
      //       this.listData = res.data.data.data;
      //       // console.log(this.listData);
      //     }
      //   });
      // } else if (this.activeIndex == 2) {
      //   newsList({
      //     type: 2,
      //     limit: this.pagesize,
      //     page: this.pagenum,
      //   }).then((res) => {
      //     if (res.data.code == 1) {
      //       // console.log(res.data.data);
      //       // 总条数
      //       this.total = res.data.data.total;
      //       this.listData = res.data.data.data;
      //       // console.log(this.listData);
      //     }
      //   });
      // }

      // console.log(this.listData);

      // this.init();
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      //把最新的页码（newPage）赋值给 动态的 pagenum
      this.pagenum = newPage;

      //获取到最新显示的页码值  重新发送axios请求 这里是封装好的请求方法

      this.init();
      // if (this.activeIndex == 1) {
      //   newsList({
      //     type: 1,
      //     limit: this.pagesize,
      //     page: this.pagenum,
      //   }).then((res) => {
      //     if (res.data.code == 1) {
      //       // console.log(res.data.data);
      //       // 总条数
      //       this.total = res.data.data.total;
      //       this.listData = res.data.data.data;
      //       // console.log(this.listData);
      //     }
      //   });
      // } else if (this.activeIndex == 2) {
      //   newsList({
      //     type: 2,
      //     limit: this.pagesize,
      //     page: this.pagenum,
      //   }).then((res) => {
      //     if (res.data.code == 1) {
      //       // console.log(res.data.data);
      //       // 总条数
      //       this.total = res.data.data.total;
      //       this.listData = res.data.data.data;
      //       // console.log(this.listData);
      //     }
      //   });
      // }
    },
    //监听 pagesize 改变的事件
    handleSizeChange(newsize) {
      //这里conso 选中第几页 最新的值
      // console.log(newsize);
      //最新的条数（newsize）赋值给 动态的 pagesie
      this.pagesize = newsize;
      this.pagenum = 1;
      //获取到最新一页显示的数据  重新发送axios请求 这里是封装好的请求方法
      // this.init();
      // if (this.activeIndex == 1) {
      //   newsList({
      //     type: 1,
      //     limit: this.pagesize,
      //     page: this.pagenum,
      //   }).then((res) => {
      //     if (res.data.code == 1) {
      //       // console.log(res.data.data);
      //       // 总条数
      //       this.total = res.data.data.total;
      //       this.listData = res.data.data.data;
      //       // console.log(this.listData);
      //     }
      //   });
      // } else if (this.activeIndex == 2) {
      //   newsList({
      //     type: 2,
      //     limit: this.pagesize,
      //     page: this.pagenum,
      //   }).then((res) => {
      //     if (res.data.code == 1) {
      //       // console.log(res.data.data);
      //       // 总条数
      //       this.total = res.data.data.total;
      //       this.listData = res.data.data.data;
      //       // console.log(this.listData);
      //     }
      //   });
      // }
    },
    // 获取所有类型的数据
    init() {
      //  type  1=阁韵新闻,2=媒体报道
      newsList({
        // type: this.activeIndex,
        limit: this.pagesize,
        page: this.pagenum,
      }).then((res) => {
        if (res.data.code == 1) {
          // console.log(res.data.data);
          // 总条数
          this.total = res.data.data.total;
          this.listData = res.data.data.data;
          console.log(this.listData);
        }
      });
    },

    // 进入详情
    detail(id, item, list) {
      // console.log(id);
      // console.log(item);
      newsDetail({ id: id }).then((res) => {
        if (res.data.code == 1) {
          console.log(res.data.data);
          this.$router.push({
            name: "Detail",
            params: {
              id: id,
              item: item,
              list: list,
              previd: res.data.data.pre_id,
              nextid: res.data.data.next_id,
              prevtitle: res.data.data.pre_title,
              nexttitle: res.data.data.next_title,
            },
          });
        }
      });
      // this.showDetail = index + (this.page - 1) * 4;
      // console.log(this.showDetail, "父级");
      // this.top();
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #004c31 !important;
}
.page {
  text-align: center;
  padding: 10px 0;
}
.dynamic {
  overflow: hidden;

  .top {
    text-align: left;
    margin-left: 320px;
    background: #ffffff;
    width: 100%;
    padding: 59px 0;

    .title {
      font-size: 42px;
      font-family: MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 24px;
    }
    .line {
      width: 90px;
      height: 8px;
    }
    .desc {
      margin-top: 32px;
      font-size: 24px;
      color: #004c31;
    }
  }
  .tab {
    background: #f2f2f2;
    border-radius: 50px;
    margin-left: 320px;
    margin-bottom: 32px;
    width: 300px;
    display: flex;
    align-items: center;
    .icon {
      width: 45px;
      height: 45px;
      img {
        width: 45px;
        height: 45px;
      }
    }
    .list {
      width: 250px;
      font-size: 20px;
      font-weight: bold;
      display: flex;
      align-items: center;
      color: #6c7a77;
      justify-content: space-around;
      & :nth-child(3) {
        border-right: unset !important;
      }
      div {
        width: 150px;
        border-right: 1px solid #ccc;
        cursor: pointer;
        &:hover {
          font-weight: bold;
          color: #004c31;
        }
      }
      .active {
        position: relative;
        font-weight: bold;
        color: #004c31;
        &::after {
          content: "";
          border: 15px solid transparent;
          border-bottom-color: #f2f2f2;
          position: absolute;
          top: 45px;
          left: 70px;
        }
      }
    }
  }
  .contentWrap {
    background: #f2f2f2;
    padding: 20px 0;
    .newsWrap {
      margin: 31px auto 0;
      width: 1280px;
      background: #ffffff;
      display: flex;
      align-items: flex-start;
      height: 326px;
      .newsImg {
        width: 526px;
        height: 266px;
        img {
          width: 526px;
          height: 266px;
        }
      }
      .right {
        margin-top: 66px;
        margin-left: 49px;
        text-align: left;
        .title {
          cursor: pointer;
          font-size: 24px;
          font-weight: bold;
          color: #004c31;
        }
        .desc {
          margin-top: 24px;
          width: 634px;
          font-size: 20px;
          color: #6c7a77;
          line-height: 36px;
        }
        .btn {
          margin-top: 12px;
          float: right;
          width: 124px;
          height: 42px;
          color: #6c7a77;
          border: 1px solid #6c7a77;
          background: #ffffff;
          font-size: 14px;
          border-radius: 50px;
          text-align: center;
          line-height: 42px;
          cursor: pointer;
          &:hover {
            color: #ffffff;
            background: #004c31;
            border: 1px solid #004c31;
          }
        }
      }
    }
  }
  .location {
    height: 85px;
    padding-bottom: 20px;
    width: 100%;
    background: #ffffff;
    display: flex;
    align-items: flex-end;
    .loca {
      margin-left: 320px;
      font-size: 24px;
      color: #004c31;
    }
  }
  .normal {
    width: 1280px;
    margin: 31px auto 0;
    background: #ffffff;
    padding-bottom: 52px;
    .cont {
      padding: 46px 39px;
      border-bottom: 1px dotted #ccc;
      .norTitle {
        font-size: 32px;
        font-weight: bold;
        color: #004c31;
        text-align: left;
      }
      .autho {
        text-align: left;
        font-size: 14px;
        color: #6c7a77;
        margin-top: 23px;
      }
    }
    .text {
      padding: 40px;
      text-align: justify;
      width: 1197px;
      font-size: 20px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #6c7a77;
      line-height: 36px;
    }
    .descImg {
      margin: 0 auto;
      width: 800px;
      height: 452px;
      img {
        width: 800px;
        height: 452px;
      }
    }
    .descImg1 {
      margin: 0 auto;
      width: 1080px;
      height: 810px;
      img {
        width: 1080px;
        height: 810px;
      }
    }
  }
  .bottom {
    width: 1200px;
    margin: 49px auto 0;
    padding-bottom: 100px;
    .prew {
      display: flex;
      align-items: center;
      cursor: pointer;
      &:hover .last {
        background: #004c31;
        border-color: #004c31;
        color: #ffffff;
      }
      &:hover .sub {
        color: #004c31;
      }
      .last {
        width: 145px;
        height: 40px;
        border: 1px solid #6c7a77;
        color: #6c7a77;
        font-size: 18px;
        text-align: center;
        line-height: 40px;
      }
      .sub {
        font-size: 20px;
        color: #6c7a77;
        margin-left: 26px;
      }
    }
    .line {
      width: 1200px;
      height: 1px;
      border-bottom: 1px dotted #6c7a77;
      margin: 10px auto;
    }
    .back {
      cursor: pointer;
      width: 145px;
      height: 41px;
      background: #004c31;
      color: #ffffff;
      margin-top: 42px;
      text-align: center;
      line-height: 41px;
      margin-left: 1055px;
    }
  }
}
@media screen and (max-width: 450px) {
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    font-size: 64px !important;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #004c31 !important;
    height: 5.458vw;
    line-height: 5.458vw;
  }
  /deep/.el-pagination .number {
    font-size: 64px !important;
  }
  /deep/.el-pagination.is-background .btn-prev {
    height: 5.458vw;
    line-height: 5.458vw;
    span {
      height: 5.458vw;
      line-height: 5.458vw;
      display: inline-block;
      font-size: 42px;
      padding: 0 20px;
    }
  }
  /deep/.el-pagination {
    display: flex;
    align-items: center;
    height: 5.458vw;
    line-height: 5.458vw;
  }
  /deep/.el-pager {
    height: 5.458vw;
    line-height: 5.458vw;
    display: flex;
    align-items: center;
  }
  /deep/.el-pagination.is-background .btn-next {
    height: 5.458vw;
    line-height: 5.458vw;
    padding: 0 20px;
    span {
      height: 5.458vw;
      line-height: 5.458vw;
      display: inline-block;
      font-size: 42px;
    }
  }
  .dynamic {
    overflow: hidden;

    .top {
      text-align: left;
      margin-left: 20px;
      background: #ffffff;
      width: auto;
      padding: 59px 0;
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 24 * 2px;
      }

      .desc {
        margin-top: 32 * 2px;
        font-size: 24 * 2px;
        color: #004c31;
      }
    }
    .tab {
      background: #f2f2f2;
      border-radius: 50px;
      margin-left: 20px;
      margin-bottom: 32px;
      width: 496 * 2.1px;
      display: flex;
      align-items: center;
      .icon {
        width: 45 * 2px;
        height: 45 * 2px;
        img {
          width: 45 * 2px;
          height: 45 * 2px;
        }
      }
      .list {
        width: 600 * 2px;
        font-size: 20 * 2px;
        font-weight: bold;
        display: flex;
        align-items: center;
        color: #6c7a77;
        justify-content: space-around;
        & :nth-child(3) {
          border-right: unset !important;
        }
        div {
          width: 150 * 2px;
          border-right: 1px solid #ccc;
          cursor: pointer;
          &:hover {
            font-weight: bold;
            color: #004c31;
          }
        }
        .active {
          position: relative;
          font-weight: bold;
          color: #004c31;
          &::after {
            content: "";
            border: 15px solid transparent;
            border-bottom-color: #f2f2f2;
            position: absolute;
            top: 45px;
            left: 70px;
          }
        }
      }
    }
    .contentWrap {
      background: #f2f2f2;
      padding: 20px 0;
      .newsWrap {
        margin: 31px auto 0;
        width: auto;
        background: #ffffff;
        display: flex;
        align-items: flex-start;
        height: auto;
        padding: 32px 0;
        .newsImg {
          width: 526 * 1.5px;
          height: 266 * 1.5px;
          img {
            width: 526 * 1.5px;
            height: 266 * 1.5px;
          }
        }
        .right {
          margin-top: 66px;
          margin-left: 49px;
          text-align: left;
          .title {
            font-size: 24 * 2px;
            font-weight: bold;
            color: #004c31;
            width: 1000px;
          }
          .desc {
            margin-top: 24 * 2px;
            width: 634 * 1.5px;
            font-size: 20 * 2px;
            color: #6c7a77;
            line-height: unset;
          }
          .btn {
            margin-top: 12 * 2px;
            float: right;
            width: 124 * 3px;
            height: 42 * 3px;
            color: #6c7a77;
            border: 1px solid #6c7a77;
            background: #ffffff;
            font-size: 14 * 2px;
            border-radius: 200px;
            text-align: center;
            line-height: 42 * 3px;
            cursor: pointer;
            &:hover {
              color: #ffffff;
              background: #004c31;
              border: 1px solid #004c31;
            }
          }
        }
      }
    }
    .location {
      height: 85 * 2px;
      padding-bottom: 20 * 2px;
      width: 100%;
      background: #ffffff;
      display: flex;
      align-items: flex-end;
      .loca {
        text-align: left;
        margin-left: 0px;
        font-size: 24 * 2px;
        color: #004c31;
      }
    }
    .normal {
      width: auto;
      margin: 31px auto 0;
      background: #ffffff;
      padding-bottom: 52px;
      .cont {
        padding: 46px 39px;
        border-bottom: 1px dotted #ccc;
        .norTitle {
          font-size: 32 * 2px;
          font-weight: bold;
          color: #004c31;
          text-align: left;
        }
        .autho {
          text-align: left;
          font-size: 14 * 2px;
          color: #6c7a77;
          margin-top: 23 * 2px;
        }
      }
      .text {
        padding: 40 * 2px;
        text-align: justify;
        width: auto;
        font-size: 20px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #6c7a77;
        line-height: unset;
      }
      .descImg {
        margin: 0 auto;
        width: 800 * 2px;
        height: 452 * 2px;
        img {
          width: 800 * 2px;
          height: 452 * 2px;
        }
      }
    }
    .bottom {
      width: auto;
      margin: 49 * 2px auto 0;
      padding-bottom: 100px;
      .prew {
        display: flex;
        align-items: center;
        cursor: pointer;
        &:hover .last {
          background: #004c31;
          border-color: #004c31;
          color: #ffffff;
        }
        &:hover .sub {
          color: #004c31;
        }
        .last {
          width: 145 * 2px;
          height: 40 * 2px;
          border: 1px solid #6c7a77;
          color: #6c7a77;
          font-size: 18 * 2px;
          text-align: center;
          line-height: 40 * 2px;
        }
        .sub {
          font-size: 20 * 2px;
          color: #6c7a77;
          margin-left: 26 * 2px;
        }
      }
      .line {
        width: 1200px;
        height: 1px;
        border-bottom: 1px dotted #6c7a77;
        margin: 10px auto;
      }
      .back {
        font-size: 32px;
        cursor: pointer;
        width: 145 * 2px;
        height: 41 * 2px;
        background: #004c31;
        color: #ffffff;
        margin-top: 42 * 2px;
        text-align: center;
        line-height: 41 * 2px;
        margin-left: 1055 * 1.2px;
      }
    }
  }
}
</style>
